var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_541_1947",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_541_1947)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 21.5V17.7385C6.05 16.8718 5.3125 15.8978 4.7875 14.8163C4.2625 13.7349 4 12.6248 4 11.4861C4 9.26773 4.77777 7.38213 6.33332 5.82928C7.88889 4.27643 9.77778 3.5 12 3.5C13.8013 3.5 15.4292 4.04839 16.8837 5.14518C18.3382 6.24198 19.2814 7.65832 19.7135 9.39422L20.7503 13.4985C20.8168 13.7521 20.7692 13.9824 20.6077 14.1894C20.4462 14.3965 20.2308 14.5 19.9615 14.5H18V17.8846C18 18.3289 17.8418 18.7091 17.5255 19.0255C17.2091 19.3418 16.8289 19.5 16.3846 19.5H14V21.5H13V18.5H16.3846C16.5641 18.5 16.7115 18.4423 16.8269 18.3269C16.9423 18.2115 17 18.0641 17 17.8846V13.5H19.7L18.75 9.625C18.3667 8.09552 17.5436 6.85897 16.2808 5.91537C15.018 4.97179 13.591 4.5 12 4.5C10.0667 4.5 8.41667 5.17687 7.05 6.5306C5.68333 7.88433 5 9.53054 5 11.4692C5 12.4659 5.20417 13.4128 5.6125 14.3099C6.02083 15.2069 6.6 16.0043 7.35 16.702L8 17.3V21.5H7ZM11.807 16.3077C12.0139 16.3077 12.1875 16.2377 12.3279 16.0978C12.4683 15.9579 12.5385 15.7845 12.5385 15.5776C12.5385 15.3707 12.4685 15.1971 12.3286 15.0567C12.1886 14.9163 12.0152 14.8462 11.8084 14.8462C11.6015 14.8462 11.4279 14.9161 11.2875 15.0561C11.1471 15.196 11.0769 15.3694 11.0769 15.5763C11.0769 15.7831 11.1469 15.9567 11.2868 16.0971C11.4268 16.2375 11.6002 16.3077 11.807 16.3077ZM11.3846 13.5692H12.275C12.275 13.2679 12.3388 12.9817 12.4663 12.7106C12.5939 12.4394 12.8244 12.1269 13.1577 11.7731C13.4449 11.4526 13.7173 11.1279 13.975 10.799C14.2327 10.4702 14.3615 10.0756 14.3615 9.61538C14.3615 8.99076 14.1292 8.46281 13.6644 8.03152C13.1997 7.60024 12.6058 7.3846 11.8827 7.3846C11.3314 7.3846 10.8266 7.5314 10.3683 7.825C9.90994 8.11858 9.56602 8.50961 9.33652 8.99807L10.1346 9.36153C10.3026 9.02051 10.5452 8.74712 10.8625 8.54135C11.1798 8.33558 11.5199 8.2327 11.8827 8.2327C12.3263 8.2327 12.701 8.36132 13.0067 8.61855C13.3125 8.8758 13.4654 9.20808 13.4654 9.61538C13.4654 9.99103 13.3516 10.3131 13.124 10.5817C12.8965 10.8503 12.6474 11.1263 12.3769 11.4096C12.0436 11.7468 11.7949 12.0904 11.6308 12.4404C11.4667 12.7904 11.3846 13.1667 11.3846 13.5692Z",
    fill: "#3A5F77"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiFaq);
export default __webpack_public_path__ + "static/media/AI_FAQ.2b7bd404a4e21d461e6308244fe6bb8c.svg";
export { ForwardRef as ReactComponent };